import { requestApi } from 'api/api'
import {
  CreatePortfolioRequest,
  GetPortfoliosParams,
  GetPortfoliosResponse,
  GetRewardsProductsParams,
  GetRewardsProductsResponse,
  Portfolio,
  PortfolioTransportRequest,
  PortfolioTransportResponse,
} from 'types/rewards'

export const createPortfolio = async (data: CreatePortfolioRequest): Promise<Portfolio> => {
  return requestApi({
    url: '/earn/v1/portfolios',
    method: 'POST',
    data,
  })
}

export const getPortfolios = async ({
  pageNumber,
  pageSize,
}: GetPortfoliosParams): Promise<GetPortfoliosResponse> => {
  return requestApi({
    url: '/earn/v1/portfolios',
    method: 'GET',
    params: {
      ...(pageNumber && { pageNumber }),
      ...(pageSize && { pageSize }),
    },
  })
}

export const getPortfolio = async (portfolioId: string): Promise<Portfolio> => {
  return requestApi({
    url: `/earn/v1/portfolios/${portfolioId}`,
    method: 'GET',
  })
}

export const depositToPortfolio = async (
  data: PortfolioTransportRequest
): Promise<PortfolioTransportResponse> => {
  return requestApi({
    url: '/earn/v1/deposits',
    method: 'POST',
    data,
  })
}

export const withdrawFromPortfolio = async (
  data: PortfolioTransportRequest
): Promise<PortfolioTransportResponse> => {
  return requestApi({
    url: '/earn/v1/withdrawals',
    method: 'POST',
    data,
  })
}

export const getRewardsProducts = async ({
  pageSize,
  pageNumber,
  currency,
}: GetRewardsProductsParams): Promise<GetRewardsProductsResponse> => {
  return requestApi({
    url: '/earn/v1/earning-products',
    method: 'GET',
    params: {
      ...(pageSize && { pageSize }),
      ...(pageNumber && { pageNumber }),
      ...(currency && { currency }),
    },
  })
}

export const getRewardsProduct = async (
  rewardsProductId: string
): Promise<GetRewardsProductsResponse> => {
  return requestApi({
    url: `/earn/v1/earning-products/${rewardsProductId}`,
    method: 'GET',
  })
}
